const dbName = "G2Database"
const objectStoreName = "G2ObjectStore"
const dbVersion = 1

const openDB = () => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(dbName, dbVersion)

        request.onerror = (event) => {
            reject(`Error opening database: ${event.target.error}`)
        }

        request.onsuccess = (event) => {
            resolve(event.target.result)
        }

        request.onupgradeneeded = (event) => {
            const db = event.target.result
            if (!db.objectStoreNames.contains(objectStoreName)) {
                db.createObjectStore(objectStoreName)
            }
        }
    })
}

export const setItem = (id, data) => {
    return openDB().then(db => {
        const transaction = db.transaction(objectStoreName, "readwrite")
        const store = transaction.objectStore(objectStoreName)

        return new Promise((resolve, reject) => {
            console.log("Setting item", id, data)
            const request = store.put(data, id)

            request.onsuccess = () => {
                resolve("Data added successfully")
            }

            request.onerror = (event) => {
                reject(`Error adding data: ${event.target.error}`)
            }
        })
    })
}

export const getItem = (id) => {
    return openDB().then(db => {
        const transaction = db.transaction(objectStoreName, "readonly")
        const store = transaction.objectStore(objectStoreName)

        return new Promise((resolve, reject) => {
            const request = store.get(id)

            request.onsuccess = (event) => {
                const data = event.target.result
                resolve(data)
            }

            request.onerror = (event) => {
                reject(`Error reading data: ${event.target.error}`)
            }
        })
    })
}

export const clearItems = () => {
    return openDB().then(db => {
        const transaction = db.transaction(objectStoreName, "readwrite")
        const store = transaction.objectStore(objectStoreName)
        
        return new Promise((resolve, reject) => {
            const request = store.clear()
            
            request.onsuccess = () => {
                resolve("Data cleared successfully")
            }
            
            request.onerror = (event) => {
                reject(`Error clearing data: ${event.target.error}`)
            }
        })
    }) 
}